export default "__VITE_ASSET__zBTjhLld__"